import { useEffect, useState } from 'react';
import { useGetInventoryV2ListEnabled } from '~/config/firebase/remote-config';

export const INVENTORY_V2_FLAG_WAIT_MS = 3000;

/**
 * Whether `/inventory` shows the paged list (`inventory_v2_list`). `isLoaded` is false until
 * remote config resolves. `timedOut` turns true when it has not resolved within
 * {@link INVENTORY_V2_FLAG_WAIT_MS}; callers then treat the flag as off.
 */
export const useInventoryV2ListEnabled = () => {
  const { data, isLoaded } = useGetInventoryV2ListEnabled();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      return undefined;
    }
    const timer = setTimeout(() => setTimedOut(true), INVENTORY_V2_FLAG_WAIT_MS);
    return () => clearTimeout(timer);
  }, [isLoaded]);

  return { enabled: !!data, isLoaded, timedOut };
};
